var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnergyWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 64,
    fill: "#EDEDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7068,
    transform: "translate(-218 -4065)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1196,
    transform: "translate(-223 -969)",
    fill: "#312F30"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -23.5,
    y: -163,
    width: 577,
    height: 123,
    rx: 15,
    fill: "white",
    fillOpacity: 0.05,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -23.5,
    y: -24,
    width: 577,
    height: 123,
    rx: 15,
    fill: "white",
    fillOpacity: 0.05,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5004 35.3917C32.2621 35.3917 32.0237 35.3366 31.8221 35.2083C31.1621 34.8233 30.9421 33.98 31.3087 33.3383L32.8671 30.625H31.3271C30.4104 30.625 29.6587 30.2216 29.2554 29.5433C28.8521 28.8466 28.8887 28.0033 29.3471 27.1966L31.3087 23.7866C31.6937 23.1266 32.5371 22.9066 33.1787 23.2733C33.8387 23.6583 34.0587 24.5016 33.6921 25.1433L32.1337 27.875H33.6737C34.5904 27.875 35.3421 28.2783 35.7454 28.9566C36.1487 29.6533 36.1121 30.4966 35.6537 31.3033L33.6921 34.7133C33.4354 35.1533 32.9771 35.3917 32.5004 35.3917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5787 46.2085H27.477C26.6704 46.2085 25.6437 46.1168 24.9654 45.4201C24.3054 44.7418 24.3237 43.8985 24.342 43.3301V41.6985C19.722 38.6185 16.6787 33.2651 16.6787 28.1685C16.6787 23.3468 18.842 18.8368 22.6004 15.8118C26.3587 12.7868 31.2904 11.6501 36.112 12.7135C40.6954 13.7218 44.6554 16.7835 46.7087 20.9085C50.687 28.9201 46.8554 37.5918 40.732 41.7168V43.0918C40.7504 43.6235 40.7687 44.5951 40.017 45.3651C39.4487 45.9151 38.642 46.2085 37.5787 46.2085ZM27.0737 43.4401C27.1654 43.4401 27.2937 43.4585 27.4587 43.4585H37.5787C37.762 43.4585 37.8904 43.4401 37.9637 43.4218C37.9637 43.3668 37.9637 43.2935 37.9637 43.2385V40.9285C37.9637 40.4518 38.2204 39.9935 38.6237 39.7551C44.0504 36.4735 47.6437 28.9751 44.2154 22.1001C42.5287 18.7085 39.2654 16.1968 35.4887 15.3718C31.492 14.4918 27.4037 15.4268 24.287 17.9385C21.1704 20.4501 19.392 24.1718 19.392 28.1685C19.392 33.2651 22.912 37.6651 26.3954 39.7735C26.817 40.0301 27.0554 40.4701 27.0554 40.9468V43.4218C27.0737 43.4218 27.0737 43.4218 27.0737 43.4401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9167 51.7085C38.7884 51.7085 38.6601 51.6901 38.5317 51.6535C34.5717 50.5168 30.4101 50.5168 26.4501 51.6535C25.7167 51.8551 24.9651 51.4335 24.7451 50.7001C24.5251 49.9668 24.9651 49.2151 25.6984 48.9951C30.1351 47.7301 34.8467 47.7301 39.2834 48.9951C40.0167 49.1968 40.4384 49.9668 40.2367 50.7001C40.0717 51.3235 39.5217 51.7085 38.9167 51.7085Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -47.5,
    y: -163,
    width: 625,
    height: 171,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_0_1",
    x: -47.5,
    y: -28,
    width: 625,
    height: 175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_0_1",
    result: "effect2_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7068,
    fill: "white",
    transform: "translate(-218 -4065)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyWhite);
export default __webpack_public_path__ + "static/media/energy-white.aedd674f7c76f0873a255f9b65273082.svg";
export { ForwardRef as ReactComponent };